import { indexItems } from "@/mocks/homeData";

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            主题索引
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            按类型快速浏览全站影视资源，找到你感兴趣的内容分类
          </p>
        </div>

        <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-xl p-4 md:p-5 text-center cursor-pointer group border border-background-200/60 hover:border-primary-200 hover:bg-background-50 transition-all"
            >
              <div className="w-11 h-11 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                <i className={`${item.icon} text-primary-600 text-xl group-hover:text-background-50 transition-colors`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-1 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <span className="text-[11px] text-foreground-400">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}